// Describe of role model
// https://nexway.atlassian.net/wiki/spaces/IT/pages/80838719/FRQ-88+Role+model+to+be+implemented+in+MyNexway
import { TABLE_SCOPE } from './index';

export const PERMISSION_RESOURCE = {
  NX_KASPERSKY_LED: 'nx-kaspersky-led',
  NX_ESET_DEXTER: 'nx-eset-dexter',
  NX_REFERENTIAL: 'nx-referential',
  NX_IAP_PAGEVIEW_LOGGER: 'nx-iap-pageview-logger',
  NX_IAP_AUDIT: 'nx-iap-audit',
  NX_DIGITALCONTENT_ORDERS: 'nx-digitalcontent-orders',
  NX_IAP_DISCOUNT: 'nx-iap-discount',
  NX_IAP_MARKETPLACE_ORDER: 'nx-iap-marketplace-order',
  NX_IAP_INVOICES_EXPORT: 'nx-iap-invoices-export',
  NX_IAP_DESIGN: 'nx-iap-design',
  NX_CUSTOMER_NOTIFIER: 'nx-customer-notifier',
  NX_KASPERSKY_PROXY: 'nx-kaspersky-proxy',
  NX_IAP_ORDER_SCHEDULER: 'nx-iap-order-scheduler',
  NX_IAP_INSTALLMENTS: 'nx-iap-installments',
  NX_TANDC: 'nx-tandc',
  NX_ORDER_SG: 'nx-order-sg',
  NX_IAP_ASSET: 'nx-iap-asset',
  NX_TAX_ENGINE: 'nx-tax-engine',
  NX_IAP_CUSTOMER_NOTIFICATION_REGENERATOR: 'nx-iap-customer-notification-regenerator',
  CUSTOMER_SERVICE: 'customer-service',
  NX_IAP_ONBOARDING: 'nx-iap-onboarding',
  NX_IAP_ENV_SYNC: 'nx-iap-env-sync',
  NX_KASPERSKY_LED_PROCESSOR: 'nx-kaspersky-led-processor',
  ORDER_SERVICE: 'order-service',
  NX_ZENDESK: 'nx-zendesk',
  FIELD_CONFIGURATOR_SERVICE: 'field-configurator-service',
  NX_LICENSE_MANAGER: 'nx-license-manager',
  NX_IAP_SUBSCRIPTION: 'nx-iap-subscription',
  NEXWAY_CENTER_FEATURE: 'nexway-center-feature',
  NX_ECOMMERCE_SUBSCRIPTION: 'nx-ecommerce-subscription',
  ENDUSER_SERVICE: 'enduser-service',
  NX_CONSENT_MANAGER: 'nx-consent-manager',
  NX_FULFILLMENT: 'nx-fulfillment',
  NX_INVOICE_BUILDER: 'nx-invoice-builder',
  NX_AVAST_PROXY: 'nx-avast-proxy',
  NX_TAX_MANAGER: 'nx-tax-manager',
  NX_ORDER_REPAIR: 'nx-order-repair',
  NX_KASPERSKY_KORM: 'nx-kaspersky-korm',
  KEYCLOAK_SERVICE: 'keycloak-service',
  NX_LICENSE_KEY_PROVIDER: 'nx-license-key-provider',
  NX_CATALOG_FREE: 'nx-catalog-free',
  NX_CAMPAIGN_CONFIGURATOR: 'nx-campaign-configurator',
  PURCHASE_SERVICE: 'purchase-service',
  STORE_SERVICE: 'store-service',
  NX_SUBSIDIARY: 'nx-subsidiary',
  NX_KASPERSKY_KORM_JAVA: 'nx-kaspersky-korm-java',
  NX_PRODUCT_RECO: 'nx-product-reco',
  CART_SERVICE: 'cart-service',
  NX_SUB_LOCKER: 'nx-sub-locker',
  NX_PAYMENT_PROXY: 'nx-payment-proxy',
  NX_IAP_PRICE: 'nx-iap-price',
  NX_IAP_IMPORT_EXPORT: 'nx-iap-import-export',
  PRODUCT_SERVICE: 'product-service',
  NX_IAP_MARKETING_CAMPAIGN: 'nx-iap-marketing-campaign',
  NX_KASPERSKY_CDB: 'nx-kaspersky-cdb',
  EMAIL_BUILDER_SERVICE: 'email-builder-service',
  NX_VATCHECK: 'nx-vatcheck',
  NX_BILLING_PLAN: 'nx-billing-plan',
  NX_PENTAHO_PROXY: 'nx-pentaho-proxy',
  NX_BITDEFENDER_PROXY: 'nx-bitdefender-proxy',
  NX_DISCLAIMER: 'nx-disclaimer',
  NX_IAP_PRICE_HISTORY: 'nx-iap-price-history',
  NX_PLATFORM_NEWS: 'nx-platform-news',
  NX_ZIPCODE: 'nx-zipcode',
  TNC_MANAGER_RUNNING: 'tnc-manager-service',
  NX_SUB_MONITORING: 'nx-sub-monitoring',
};

export const PERMISSION_LEVEL = {
  ALL: 'all',
  GET: 'get',
  LIST: 'list',
  PUT: 'put',
  POST: 'post',
  DELETE: 'delete',
  MANAGE: 'manage',
  READ: 'read',
  OPERATE: 'operate',
  GET_PENTAHO_DASHBOARD: 'getPentahoDashboard',
  MANAGE_PREFERENCES: 'managePreferences',
  SELF_MANAGEMENT: 'selfManagement',
  READ_SUBSCRIPTION: 'readSubscription',
  READ_SUBSCRIPTIONS: 'readSubscriptions',
  READ_LICENSES: 'readLicenses',
  READ_FULLFILLMENTS: 'readFulfillments',
  READ_PARTNERS: 'readPartners',
  READ_LOGS: 'readLogs',
  GET_PARTNER: 'getPartner',
  GET_FULFILLMENT: 'getFulfillment',
  READ_LICENSE_PROVIDER_DEFINITIONS: 'readLicenseProviderDefinitions',
  POST_LICENSE_PROVIDER_DEFINITIONS: 'postLicenseProviderDefinitions',
  PUT_LICENSE_PROVIDER_DEFINITIONS: 'putLicenseProviderDefinitions',
  DELETE_LICENSE_PROVIDER_DEFINITIONS: 'deleteLicenseProviderDefinitions',
  LIST_DESIGNS: 'listDesigns',
  POST_DESIGNS: 'postDesigns',
  PUT_DESIGNS: 'putDesigns',
  DELETE_DESIGNS: 'deleteDesigns',
  LIST_LEGAL_I18NS: 'listLegalI18ns',
  PUT_LEGAL_I18NS: 'putLegalI18ns',
  POST_LEGAL_I18NS: 'postLegalI18ns',
  DELETE_LEGAL_I18NS: 'deleteLegalI18ns',
  MANAGE_LEGAL_I18NS: 'manageLegalI18ns',
  READ_CAMPAIGNS: 'readCampaigns',
  READ_LINKED_PRODUCTS: 'readLinkedProducts',
  READ_CONSENTS: 'readConsents',
  READ_IDENTITIES: 'readIdentities',
  POWER_TOOLS: 'powerTools',
  READ_REALMS: 'readRealms',
  READ_AUDIT_ITEMS: 'readAuditItems',
  READ_NOTIFICATIONS: 'readNotifications',
  PUT_NOTIFICATIONS: 'putNotifications',
  READ_RECEIVERS: 'readReceivers',
  POST_RECEIVERS: 'postReceivers',
  PUT_RECEIVERS: 'putReceivers',
  DELETE_RECEIVERS: 'deleteReceivers',
  READ_NOTIFICATIONS_DEFINITIONS: 'readNotificationDefinitions',
  POST_NOTIFICATIONS_DEFINITIONS: 'postNotificationDefinitions',
  PUT_NOTIFICATIONS_DEFINITIONS: 'putNotificationDefinitions',
  DELETE_NOTIFICATIONS_DEFINITIONS: 'deleteNotificationDefinitions',
  READ_SUBSIDIARIES: 'readSubsidiaries',
  READ_SUBSIDIARY_RULES: 'readSubsidiaryRules',
  SEND_EMAIL: 'sendEmail',
  CANCEL_ORDER: 'cancelOrder',
  REPAIR_ORDER: 'repairOrder',
  RESYNC_ENDUSER: 'resyncEndUser',
  POST_IDENTITIES: 'postIdentities',
  DELETE_IDENTITIES: 'deleteIdentities',
  PUT_IDENTITIES: 'putIdentities',
  READ_ROLES: 'readRoles',
  READ_METAROLES: 'readMetaroles',
  READ_PRIVILEGAS: 'readPrivileges',
  POST_ROLES: 'postRoles',
  DELETE_ROLES: 'deleteRoles',
  PUT_ROLES: 'putRoles',
  POST_METAROLES: 'postMetaroles',
  DELETE_METAROLES: 'deleteMetaroles',
  PUT_METAROLES: 'putMetaroles',
  LIST_PACKAGE: 'listPackage',
  PUT_CAMPAIGNS: 'putCampaigns',
  PUT_LINKED_PRODUCTS: 'putLinkedProducts',
  MANAGE_PRIVILEGES: 'managePrivileges',
  MANAGE_SUBSCRIPTIONS: 'manageSubscriptions',
  EXPORT_SUBSCRIPTION: 'ExportSubscription',
  EXPORT_PRODUCT: 'ExportProduct',
  EXPORT_DISCOUNT: 'ExportDiscount',
  EXPORT_FULL_PRICE: 'ExportFullPrice',
  EXPORT_PRICE: 'ExportPrice',
  IMPORT_PRICE: 'ImportPrice',
  EXPORT_ORDER: 'ExportOrder',
  PARTIAL_REFUND: 'partialRefund',
};

export const VALUE_PERMISSION_LEVELS = {
  [PERMISSION_LEVEL.GET]: 1,
  [PERMISSION_LEVEL.READ]: 1,
  [PERMISSION_LEVEL.LIST]: 1,
  [PERMISSION_LEVEL.PUT]: 2,
  [PERMISSION_LEVEL.POST]: 3,
  [PERMISSION_LEVEL.DELETE]: 4,
  [PERMISSION_LEVEL.MANAGE]: 4,
};

export const HAS_VALUE_PERMISSION_LEVELS = Object.keys(VALUE_PERMISSION_LEVELS);

export const CRUD_RESTRICTION = {
  resource: PERMISSION_RESOURCE.NEXWAY_CENTER_FEATURE,
  level: PERMISSION_LEVEL.POWER_TOOLS,
};

export const NEXWAY_SERVICES_RESTRICTIONS = [
  {
    resource: PERMISSION_RESOURCE.NX_REFERENTIAL,
    level: PERMISSION_LEVEL.READ,
  },
  {
    resource: PERMISSION_RESOURCE.NX_PENTAHO_PROXY,
    level: PERMISSION_LEVEL.GET_PENTAHO_DASHBOARD,
  },
  {
    resource: PERMISSION_RESOURCE.KEYCLOAK_SERVICE,
    level: PERMISSION_LEVEL.SELF_MANAGEMENT,
  },
];

export const TABLE_BUTTON_PERMISSIONS = {
  [TABLE_SCOPE.STORES]: {
    add: {
      resource: PERMISSION_RESOURCE.STORE_SERVICE,
      level: PERMISSION_LEVEL.POST,
    },
    delete: {
      resource: PERMISSION_RESOURCE.STORE_SERVICE,
      level: PERMISSION_LEVEL.DELETE,
    },
    edite: {
      resource: PERMISSION_RESOURCE.STORE_SERVICE,
      level: PERMISSION_LEVEL.PUT,
    },
  },
  [TABLE_SCOPE.THEMES]: {
    add: {
      resource: PERMISSION_RESOURCE.NX_IAP_DESIGN,
      level: PERMISSION_LEVEL.POST_DESIGNS,
    },
    delete: {
      resource: PERMISSION_RESOURCE.NX_IAP_DESIGN,
      level: PERMISSION_LEVEL.DELETE_DESIGNS,
    },
    edite: {
      resource: PERMISSION_RESOURCE.NX_IAP_DESIGN,
      level: PERMISSION_LEVEL.PUT_DESIGNS,
    },
  },
  [TABLE_SCOPE.LAYOUTS]: {
    add: {
      resource: PERMISSION_RESOURCE.NX_IAP_DESIGN,
      level: PERMISSION_LEVEL.POST_DESIGNS,
    },
    delete: {
      resource: PERMISSION_RESOURCE.NX_IAP_DESIGN,
      level: PERMISSION_LEVEL.DELETE_DESIGNS,
    },
    edite: {
      resource: PERMISSION_RESOURCE.NX_IAP_DESIGN,
      level: PERMISSION_LEVEL.PUT_DESIGNS,
    },
  },
  [TABLE_SCOPE.FONTS]: {
    add: {
      resource: PERMISSION_RESOURCE.NX_IAP_DESIGN,
      level: PERMISSION_LEVEL.POST_DESIGNS,
    },
    delete: {
      resource: PERMISSION_RESOURCE.NX_IAP_DESIGN,
      level: PERMISSION_LEVEL.DELETE_DESIGNS,
    },
    edite: {
      resource: PERMISSION_RESOURCE.NX_IAP_DESIGN,
      level: PERMISSION_LEVEL.PUT_DESIGNS,
    },
  },
  [TABLE_SCOPE.MARKUPS]: {
    add: {
      resource: PERMISSION_RESOURCE.NX_IAP_DESIGN,
      level: PERMISSION_LEVEL.POST_DESIGNS,
    },
    delete: {
      resource: PERMISSION_RESOURCE.NX_IAP_DESIGN,
      level: PERMISSION_LEVEL.DELETE_DESIGNS,
    },
    edite: {
      resource: PERMISSION_RESOURCE.NX_IAP_DESIGN,
      level: PERMISSION_LEVEL.PUT_DESIGNS,
    },
  },
  [TABLE_SCOPE.TRANSLATIONS]: {
    add: {
      resource: PERMISSION_RESOURCE.NX_IAP_DESIGN,
      level: PERMISSION_LEVEL.POST_DESIGNS,
    },
    delete: {
      resource: PERMISSION_RESOURCE.NX_IAP_DESIGN,
      level: PERMISSION_LEVEL.DELETE_DESIGNS,
    },
    edite: {
      resource: PERMISSION_RESOURCE.NX_IAP_DESIGN,
      level: PERMISSION_LEVEL.PUT_DESIGNS,
    },
  },
  [TABLE_SCOPE.INVOICE_TRANSLATIONS]: {
    add: {
      resource: PERMISSION_RESOURCE.NX_IAP_DESIGN,
      level: PERMISSION_LEVEL.POST_LEGAL_I18NS,
    },
    delete: {
      resource: PERMISSION_RESOURCE.NX_IAP_DESIGN,
      level: PERMISSION_LEVEL.DELETE_LEGAL_I18NS,
    },
    edite: {
      resource: PERMISSION_RESOURCE.NX_IAP_DESIGN,
      level: PERMISSION_LEVEL.PUT_LEGAL_I18NS,
    },
  },
  [TABLE_SCOPE.EMAIL_BUILDER]: {
    delete: {
      resource: PERMISSION_RESOURCE.EMAIL_BUILDER_SERVICE,
      level: PERMISSION_LEVEL.DELETE,
    },
    edite: {
      resource: PERMISSION_RESOURCE.EMAIL_BUILDER_SERVICE,
      level: PERMISSION_LEVEL.PUT,
    },
    clone: {
      resource: PERMISSION_RESOURCE.EMAIL_BUILDER_SERVICE,
      level: PERMISSION_LEVEL.OPERATE,
    },
    saveCustom: {
      resource: PERMISSION_RESOURCE.EMAIL_BUILDER_SERVICE,
      level: PERMISSION_LEVEL.PUT,
    },
    activate: {
      resource: PERMISSION_RESOURCE.EMAIL_BUILDER_SERVICE,
      level: PERMISSION_LEVEL.PUT,
    },
  },
  [TABLE_SCOPE.PRODUCT_LIST]: {
    add: {
      resource: PERMISSION_RESOURCE.PRODUCT_SERVICE,
      level: PERMISSION_LEVEL.POST,
    },
    delete: {
      resource: PERMISSION_RESOURCE.PRODUCT_SERVICE,
      level: PERMISSION_LEVEL.DELETE,
    },
    edite: {
      resource: PERMISSION_RESOURCE.PRODUCT_SERVICE,
      level: PERMISSION_LEVEL.PUT,
    },
  },
  [TABLE_SCOPE.CUSTOM_FIELDS_DEFINITION]: {
    add: {
      resource: PERMISSION_RESOURCE.PRODUCT_SERVICE,
      level: PERMISSION_LEVEL.POST,
    },
  },

  [TABLE_SCOPE.PRICES]: {
    add: {
      resource: PERMISSION_RESOURCE.NX_IAP_PRICE,
      level: PERMISSION_LEVEL.POST,
    },
    delete: {
      resource: PERMISSION_RESOURCE.NX_IAP_PRICE,
      level: PERMISSION_LEVEL.DELETE,
    },
    edite: {
      resource: PERMISSION_RESOURCE.NX_IAP_PRICE,
      level: PERMISSION_LEVEL.PUT,
    },
  },

  [TABLE_SCOPE.PRICES_FUNCTIONS]: {
    add: {
      resource: PERMISSION_RESOURCE.NX_IAP_PRICE,
      level: PERMISSION_LEVEL.POST,
    },
    delete: {
      resource: PERMISSION_RESOURCE.NX_IAP_PRICE,
      level: PERMISSION_LEVEL.DELETE,
    },
    edite: {
      resource: PERMISSION_RESOURCE.NX_IAP_PRICE,
      level: PERMISSION_LEVEL.PUT,
    },
  },

  [TABLE_SCOPE.RECOMMENDATIONS]: {
    add: {
      resource: PERMISSION_RESOURCE.NX_PRODUCT_RECO,
      level: PERMISSION_LEVEL.POST,
    },
    delete: {
      resource: PERMISSION_RESOURCE.NX_PRODUCT_RECO,
      level: PERMISSION_LEVEL.DELETE,
    },
    edite: {
      resource: PERMISSION_RESOURCE.NX_PRODUCT_RECO,
      level: PERMISSION_LEVEL.PUT,
    },
  },

  [TABLE_SCOPE.AUTO_FULFILLMENTS]: {},

  [TABLE_SCOPE.MANUAL_FULFILLMENTS]: {
    add: {
      resource: PERMISSION_RESOURCE.NX_LICENSE_KEY_PROVIDER,
      level: PERMISSION_LEVEL.POST,
    },
    edite: {
      resource: PERMISSION_RESOURCE.NX_LICENSE_KEY_PROVIDER,
      level: PERMISSION_LEVEL.PUT,
    },
  },

  [TABLE_SCOPE.LICENSES_PROVIDER_DEFINITIONS]: {
    add: {
      resource: PERMISSION_RESOURCE.NX_LICENSE_MANAGER,
      level: PERMISSION_LEVEL.POST_LICENSE_PROVIDER_DEFINITIONS,
    },
    delete: {
      resource: PERMISSION_RESOURCE.NX_LICENSE_MANAGER,
      level: PERMISSION_LEVEL.DELETE_LICENSE_PROVIDER_DEFINITIONS,
    },
    edite: {
      resource: PERMISSION_RESOURCE.NX_LICENSE_MANAGER,
      level: PERMISSION_LEVEL.PUT_LICENSE_PROVIDER_DEFINITIONS,
    },
  },

  [TABLE_SCOPE.CATALOGS]: {
    add: {
      resource: PERMISSION_RESOURCE.NX_CATALOG_FREE,
      level: PERMISSION_LEVEL.POST,
    },
    delete: {
      resource: PERMISSION_RESOURCE.NX_CATALOG_FREE,
      level: PERMISSION_LEVEL.DELETE,
    },
    edite: {
      resource: PERMISSION_RESOURCE.NX_CATALOG_FREE,
      level: PERMISSION_LEVEL.PUT,
    },
  },

  [TABLE_SCOPE.DISCOUNT_RULES]: {
    add: {
      resource: PERMISSION_RESOURCE.NX_IAP_DISCOUNT,
      level: PERMISSION_LEVEL.POST,
    },
    delete: {
      resource: PERMISSION_RESOURCE.NX_IAP_DISCOUNT,
      level: PERMISSION_LEVEL.DELETE,
    },
    edite: {
      resource: PERMISSION_RESOURCE.NX_IAP_DISCOUNT,
      level: PERMISSION_LEVEL.PUT,
    },
  },

  [TABLE_SCOPE.MARKETING_CAMPAIGNS]: {
    edite: [
      {
        resource: PERMISSION_RESOURCE.NX_IAP_MARKETING_CAMPAIGN,
        level: PERMISSION_LEVEL.PUT,
      },
      {
        resource: PERMISSION_RESOURCE.NX_IAP_MARKETING_CAMPAIGN,
        level: PERMISSION_LEVEL.PUT_CAMPAIGNS,
      },
      {
        resource: PERMISSION_RESOURCE.NX_IAP_MARKETING_CAMPAIGN,
        level: PERMISSION_LEVEL.PUT_LINKED_PRODUCTS,
      },
    ],
  },

  [TABLE_SCOPE.LICENSE_EXPIRATION]: {
    edite: [
      {
        resource: PERMISSION_RESOURCE.NX_IAP_MARKETING_CAMPAIGN,
        level: PERMISSION_LEVEL.PUT,
      },
      {
        resource: PERMISSION_RESOURCE.NX_IAP_MARKETING_CAMPAIGN,
        level: PERMISSION_LEVEL.PUT_CAMPAIGNS,
      },
      {
        resource: PERMISSION_RESOURCE.NX_IAP_MARKETING_CAMPAIGN,
        level: PERMISSION_LEVEL.PUT_LINKED_PRODUCTS,
      },
    ],
  },

  [TABLE_SCOPE.MARKETING_ABANDONED]: {
    add: {
      resource: PERMISSION_RESOURCE.NX_CAMPAIGN_CONFIGURATOR,
      level: PERMISSION_LEVEL.POST,
    },
    edite: {
      resource: PERMISSION_RESOURCE.NX_CAMPAIGN_CONFIGURATOR,
      level: PERMISSION_LEVEL.PUT,
    },
  },

  [TABLE_SCOPE.CARTS]: {
    add: {
      resource: PERMISSION_RESOURCE.CART_SERVICE,
      level: PERMISSION_LEVEL.POST,
    },
    delete: {
      resource: PERMISSION_RESOURCE.CART_SERVICE,
      level: PERMISSION_LEVEL.DELETE,
    },
  },
  [TABLE_SCOPE.ORDER_LIST]: {
    SEARCH_BY_CREDIT_CART: {
      resource: PERMISSION_RESOURCE.NX_PAYMENT_PROXY,
      level: PERMISSION_LEVEL.READ,
    },
    export: {
      resource: PERMISSION_RESOURCE.NX_IAP_IMPORT_EXPORT,
      level: PERMISSION_LEVEL.READ,
    },
  },
  [TABLE_SCOPE.CUSTOMER_LIST]: {
    add: {
      resource: PERMISSION_RESOURCE.CUSTOMER_SERVICE,
      level: PERMISSION_LEVEL.POST,
    },
    delete: {
      resource: PERMISSION_RESOURCE.CUSTOMER_SERVICE,
      level: PERMISSION_LEVEL.DELETE,
    },
    edite: {
      resource: PERMISSION_RESOURCE.CUSTOMER_SERVICE,
      level: PERMISSION_LEVEL.PUT,
    },
  },
  [TABLE_SCOPE.CUSTOMER_LIST]: {
    add: {
      resource: PERMISSION_RESOURCE.CUSTOMER_SERVICE,
      level: PERMISSION_LEVEL.POST,
    },
    delete: {
      resource: PERMISSION_RESOURCE.CUSTOMER_SERVICE,
      level: PERMISSION_LEVEL.DELETE,
    },
    edite: {
      resource: PERMISSION_RESOURCE.CUSTOMER_SERVICE,
      level: PERMISSION_LEVEL.PUT,
    },
  },
  [TABLE_SCOPE.ONBOARDING]: {
    add: {
      resource: PERMISSION_RESOURCE.NX_IAP_ONBOARDING,
      level: PERMISSION_LEVEL.POST,
    },
    delete: {
      resource: PERMISSION_RESOURCE.NX_IAP_ONBOARDING,
      level: PERMISSION_LEVEL.DELETE,
    },
    edite: {
      resource: PERMISSION_RESOURCE.NX_IAP_ONBOARDING,
      level: PERMISSION_LEVEL.PUT,
    },
  },
  [TABLE_SCOPE.NOTIFICATIONS]: {
    add: {
      resource: PERMISSION_RESOURCE.NX_CUSTOMER_NOTIFIER,
      level: PERMISSION_LEVEL.POST_RECEIVERS,
    },
    delete: {
      resource: PERMISSION_RESOURCE.NX_CUSTOMER_NOTIFIER,
      level: PERMISSION_LEVEL.DELETE_RECEIVERS,
    },
    edite: {
      resource: PERMISSION_RESOURCE.NX_CUSTOMER_NOTIFIER,
      level: PERMISSION_LEVEL.PUT_RECEIVERS,
    },
  },
  [TABLE_SCOPE.NOTIFICATIONS_DEFINITION]: {
    add: {
      resource: PERMISSION_RESOURCE.NX_CUSTOMER_NOTIFIER,
      level: PERMISSION_LEVEL.POST_NOTIFICATIONS_DEFINITIONS,
    },
    delete: {
      resource: PERMISSION_RESOURCE.NX_CUSTOMER_NOTIFIER,
      level: PERMISSION_LEVEL.DELETE_NOTIFICATIONS_DEFINITIONS,
    },
    edite: {
      resource: PERMISSION_RESOURCE.NX_CUSTOMER_NOTIFIER,
      level: PERMISSION_LEVEL.PUT_NOTIFICATIONS_DEFINITIONS,
    },
  },
  [TABLE_SCOPE.NOTIFICATIONS_HISTORY]: {
    add: {
      resource: PERMISSION_RESOURCE.NX_CUSTOMER_NOTIFIER,
      level: PERMISSION_LEVEL.PUT_NOTIFICATIONS,
    },
  },
  [TABLE_SCOPE.USERS]: {
    add: {
      resource: PERMISSION_RESOURCE.KEYCLOAK_SERVICE,
      level: PERMISSION_LEVEL.POST_IDENTITIES,
    },
    delete: {
      resource: PERMISSION_RESOURCE.KEYCLOAK_SERVICE,
      level: PERMISSION_LEVEL.DELETE_IDENTITIES,
    },
    edit: {
      resource: PERMISSION_RESOURCE.KEYCLOAK_SERVICE,
      level: PERMISSION_LEVEL.PUT_IDENTITIES,
    },
  },
  [TABLE_SCOPE.ROLES]: {
    add: {
      resource: PERMISSION_RESOURCE.KEYCLOAK_SERVICE,
      level: PERMISSION_LEVEL.POST_ROLES,
    },
    delete: {
      resource: PERMISSION_RESOURCE.KEYCLOAK_SERVICE,
      level: PERMISSION_LEVEL.DELETE_ROLES,
    },
    edit: {
      resource: PERMISSION_RESOURCE.KEYCLOAK_SERVICE,
      level: PERMISSION_LEVEL.PUT_ROLES,
    },
  },
  [TABLE_SCOPE.META_ROLES]: {
    add: {
      resource: PERMISSION_RESOURCE.KEYCLOAK_SERVICE,
      level: PERMISSION_LEVEL.POST_METAROLES,
    },
    delete: {
      resource: PERMISSION_RESOURCE.KEYCLOAK_SERVICE,
      level: PERMISSION_LEVEL.DELETE_METAROLES,
    },
    edit: {
      resource: PERMISSION_RESOURCE.KEYCLOAK_SERVICE,
      level: PERMISSION_LEVEL.PUT_METAROLES,
    },
  },
  [TABLE_SCOPE.PRIVILEGES]: {
    edit: {
      resource: PERMISSION_RESOURCE.KEYCLOAK_SERVICE,
      level: PERMISSION_LEVEL.MANAGE_PRIVILEGES,
    },
    delete: {
      resource: PERMISSION_RESOURCE.KEYCLOAK_SERVICE,
      level: PERMISSION_LEVEL.MANAGE_PRIVILEGES,
    },
  },
  [TABLE_SCOPE.END_USER_LIST]: {
    edit: {
      resource: PERMISSION_RESOURCE.ENDUSER_SERVICE,
      level: PERMISSION_LEVEL.PUT,
    },
  },
  [TABLE_SCOPE.END_USER_GROUPS]: {
    add: {
      resource: PERMISSION_RESOURCE.ENDUSER_SERVICE,
      level: PERMISSION_LEVEL.POST,
    },
    delete: {
      resource: PERMISSION_RESOURCE.ENDUSER_SERVICE,
      level: PERMISSION_LEVEL.DELETE,
    },
    edit: {
      resource: PERMISSION_RESOURCE.ENDUSER_SERVICE,
      level: PERMISSION_LEVEL.PUT,
    },
  },
  [TABLE_SCOPE.END_USERS_WALLET]: {
    delete: {
      resource: PERMISSION_RESOURCE.ENDUSER_SERVICE,
      level: PERMISSION_LEVEL.DELETE,
    },
  },
  [TABLE_SCOPE.RESELLERS]: {
    edit: {
      resource: PERMISSION_RESOURCE.ENDUSER_SERVICE,
      level: PERMISSION_LEVEL.PUT,
    },
  },
  currencies: {
    add: {
      resource: PERMISSION_RESOURCE.NX_REFERENTIAL,
      level: PERMISSION_LEVEL.POST,
    },
    delete: {
      resource: PERMISSION_RESOURCE.NX_REFERENTIAL,
      level: PERMISSION_LEVEL.DELETE,
    },
    edit: {
      resource: PERMISSION_RESOURCE.NX_REFERENTIAL,
      level: PERMISSION_LEVEL.PUT,
    },
  },
  locales: {
    add: {
      resource: PERMISSION_RESOURCE.NX_REFERENTIAL,
      level: PERMISSION_LEVEL.POST,
    },
    delete: {
      resource: PERMISSION_RESOURCE.NX_REFERENTIAL,
      level: PERMISSION_LEVEL.DELETE,
    },
    edit: {
      resource: PERMISSION_RESOURCE.NX_REFERENTIAL,
      level: PERMISSION_LEVEL.PUT,
    },
  },
  countries: {
    add: {
      resource: PERMISSION_RESOURCE.NX_REFERENTIAL,
      level: PERMISSION_LEVEL.POST,
    },
    delete: {
      resource: PERMISSION_RESOURCE.NX_REFERENTIAL,
      level: PERMISSION_LEVEL.DELETE,
    },
    edit: {
      resource: PERMISSION_RESOURCE.NX_REFERENTIAL,
      level: PERMISSION_LEVEL.PUT,
    },
  },
  subsidiaries: {
    add: {
      resource: PERMISSION_RESOURCE.NX_SUBSIDIARY,
      level: PERMISSION_LEVEL.POST,
    },
    delete: {
      resource: PERMISSION_RESOURCE.NX_SUBSIDIARY,
      level: PERMISSION_LEVEL.DELETE,
    },
    edit: {
      resource: PERMISSION_RESOURCE.NX_SUBSIDIARY,
      level: PERMISSION_LEVEL.PUT,
    },
  },
  [TABLE_SCOPE.TNC_MANAGER_RUNNING]: {
    add: {
      resource: PERMISSION_RESOURCE.NX_TANDC,
      level: PERMISSION_LEVEL.MANAGE,
    },
  },
  [TABLE_SCOPE.TNC_MANAGER_DRAFT]: {
    add: {
      resource: PERMISSION_RESOURCE.NX_TANDC,
      level: PERMISSION_LEVEL.MANAGE,
    },
  },
  [TABLE_SCOPE.TNC_MANAGER_ARCHIVED]: {
    add: {
      resource: PERMISSION_RESOURCE.NX_TANDC,
      level: PERMISSION_LEVEL.MANAGE,
    },
  },
};

export const ACTION_BUTTONS = {
  MARKETPLACE_ORDER_DETAILS_BUTTONS: {
    SEND: {
      resource: PERMISSION_RESOURCE.NX_IAP_MARKETPLACE_ORDER,
      level: PERMISSION_LEVEL.SEND_EMAIL,
    },
    CANCEL: {
      resource: PERMISSION_RESOURCE.NX_IAP_MARKETPLACE_ORDER,
      level: PERMISSION_LEVEL.CANCEL_ORDER,
    },
    REPAIR: {
      resource: PERMISSION_RESOURCE.NX_IAP_MARKETPLACE_ORDER,
      level: PERMISSION_LEVEL.REPAIR_ORDER,
    },
    RESYNC: {
      resource: PERMISSION_RESOURCE.NX_PAYMENT_PROXY,
      level: PERMISSION_LEVEL.OPERATE,
    },
  },
  ORDER_DETAILS_BUTTONS: {
    SEND: {
      resource: PERMISSION_RESOURCE.ORDER_SERVICE,
      level: PERMISSION_LEVEL.SEND_EMAIL,
    },
    CANCEL: {
      resource: PERMISSION_RESOURCE.ORDER_SERVICE,
      level: PERMISSION_LEVEL.CANCEL_ORDER,
    },
    REPAIR: {
      resource: PERMISSION_RESOURCE.ORDER_SERVICE,
      level: PERMISSION_LEVEL.REPAIR_ORDER,
    },
    RESYNC: {
      resource: PERMISSION_RESOURCE.NX_PAYMENT_PROXY,
      level: PERMISSION_LEVEL.OPERATE,
    },
    RESYNC_ENDUSER: {
      resource: PERMISSION_RESOURCE.ORDER_SERVICE,
      level: PERMISSION_LEVEL.RESYNC_ENDUSER,
    },
    RESUME_SUSPEND_SUBSCRIPTION: {
      resource: PERMISSION_RESOURCE.ENDUSER_SERVICE,
      level: PERMISSION_LEVEL.PUT,
    },
  },
};

export const ACTION_TABS = {
  EXPORT_MANAGER_TABS: {
    EXPORT_SUBSCRIPTION: {
      resource: PERMISSION_RESOURCE.NX_IAP_IMPORT_EXPORT,
      level: PERMISSION_LEVEL.EXPORT_SUBSCRIPTION,
    },
    EXPORT_PRODUCT: {
      resource: PERMISSION_RESOURCE.NX_IAP_IMPORT_EXPORT,
      level: PERMISSION_LEVEL.EXPORT_PRODUCT,
    },
    EXPORT_DISCOUNT: {
      resource: PERMISSION_RESOURCE.NX_IAP_IMPORT_EXPORT,
      level: PERMISSION_LEVEL.EXPORT_DISCOUNT,
    },
  },
};

export const ACTION_SECTIONS = {
  EXPORT_IMPORT_PRICES_SECTIONS: {
    EXPORT_FULL_PRICE_SECTION: {
      resource: PERMISSION_RESOURCE.NX_IAP_IMPORT_EXPORT,
      level: PERMISSION_LEVEL.EXPORT_FULL_PRICE,
    },
    EXPORT_PRICE_SECTION: {
      resource: PERMISSION_RESOURCE.NX_IAP_IMPORT_EXPORT,
      level: PERMISSION_LEVEL.EXPORT_PRICE,
    },
    IMPORT_PRICE_SECTION: {
      resource: PERMISSION_RESOURCE.NX_IAP_IMPORT_EXPORT,
      level: PERMISSION_LEVEL.IMPORT_PRICE,
    },
  },
};
